import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { IconButtonComponent } from './icon-button.component';

@NgModule({
  declarations: [IconButtonComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule],
  providers: [],
  exports: [IconButtonComponent],
})
export class IconButtonModule {}
